export default __webpack_public_path__ + "static/media/IMG_2.be35842f.JPG";